export enum AdminPanelCorrespondenceStatus {
  WYSLANY = 'Wysłany',
  OCZEKUJACY_NA_ODBIOR = 'Oczekujący na odbiór',
  ODEBRANY = 'Odebrany',
  ROBOCZY = 'Roboczy',
}
